function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { Polling } from "./polling.js";
/**
 * HTTP long-polling based on the built-in `fetch()` method.
 *
 * Usage: browser, Node.js (since v18), Deno, Bun
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/fetch
 * @see https://caniuse.com/fetch
 * @see https://nodejs.org/api/globals.html#fetch
 */ export var Fetch = /*#__PURE__*/ function(Polling) {
    "use strict";
    _inherits(Fetch, Polling);
    function Fetch() {
        _class_call_check(this, Fetch);
        return _call_super(this, Fetch, arguments);
    }
    _create_class(Fetch, [
        {
            key: "doPoll",
            value: function doPoll() {
                var _this = this;
                this._fetch().then(function(res) {
                    if (!res.ok) {
                        return _this.onError("fetch read error", res.status, res);
                    }
                    res.text().then(function(data) {
                        return _this.onData(data);
                    });
                }).catch(function(err) {
                    _this.onError("fetch read error", err);
                });
            }
        },
        {
            key: "doWrite",
            value: function doWrite(data, callback) {
                var _this = this;
                this._fetch(data).then(function(res) {
                    if (!res.ok) {
                        return _this.onError("fetch write error", res.status, res);
                    }
                    callback();
                }).catch(function(err) {
                    _this.onError("fetch write error", err);
                });
            }
        },
        {
            key: "_fetch",
            value: function _fetch(data) {
                var _this = this;
                var _a;
                var isPost = data !== undefined;
                var headers = new Headers(this.opts.extraHeaders);
                if (isPost) {
                    headers.set("content-type", "text/plain;charset=UTF-8");
                }
                (_a = this.socket._cookieJar) === null || _a === void 0 ? void 0 : _a.appendCookies(headers);
                return fetch(this.uri(), {
                    method: isPost ? "POST" : "GET",
                    body: isPost ? data : null,
                    headers: headers,
                    credentials: this.opts.withCredentials ? "include" : "omit"
                }).then(function(res) {
                    var _a;
                    // @ts-ignore getSetCookie() was added in Node.js v19.7.0
                    (_a = _this.socket._cookieJar) === null || _a === void 0 ? void 0 : _a.parseCookies(res.headers.getSetCookie());
                    return res;
                });
            }
        }
    ]);
    return Fetch;
}(Polling);
